import { useFlag } from '@calendly/feature-check-react'
import moment from 'moment-timezone'

import { useGetUserQuery } from 'common'
import { useFetchContactByEmailGQLQuery } from 'features/contacts'
import { CRM_MEETING_PREP_MVP_FLAG_KEY } from 'features/crm'
import { useCurrentTime } from 'shared/contexts'

export const useGenerateMeetingPrep = (event) => {
  const { data: currentUser } = useGetUserQuery()
  const currentTime = useCurrentTime()
  const meetingPrepFlag = useFlag(CRM_MEETING_PREP_MVP_FLAG_KEY)
  const oneOnOneMeeting = event.attendees?.length === 2
  const meetingIsUpcoming = moment(event.startTime).isSameOrAfter(currentTime)
  const getContactEmail = () => {
    if (!currentUser) return undefined
    if (currentUser.email === event.host?.email) {
      return event.invitee?.email
    }
    return event.host?.email
  }
  const contactEmail = getContactEmail()
  const { data: contact, isLoading: isContactLoading } = useFetchContactByEmailGQLQuery(contactEmail, {
    skip: !contactEmail || !oneOnOneMeeting || !meetingIsUpcoming || !meetingPrepFlag || event.cancelled,
  })
  const showGenerateMeetingPrep = (
    meetingPrepFlag
    && oneOnOneMeeting
    && meetingIsUpcoming
    && !event.cancelled
    && contact
    && !isContactLoading
  )

  return { showGenerateMeetingPrep, contact }
}
